import React from 'react';
import { SUPPORT_EMAIL } from '../data/constants';
export function Footer() {
  return <footer className="bg-navy py-5" data-id="element-58" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-59" data-mp="3gg0xpz2xhpvj">
        <p className="text-[11.5px] font-medium leading-snug text-steellight sm:text-[13px]" data-id="element-60" data-mp="32oe3s5wgktfx">
          © 2026 GASOLINE ENGINE DIAGNOSTIC PRO™ — All Rights Reserved. GASOLINE
          ENGINE DIAGNOSTIC PRO™ is an educational and professional reference
          resource. It does not replace manufacturer service information, OEM
          specifications, appropriate safety procedures, professional training or
          qualified technical judgment.
        </p>
        <p className="mt-2 text-[11.5px] font-semibold uppercase tracking-wide text-steellight sm:text-[13px]" data-id="element-61" data-mp="3lggbgrr4gze1">
          Terms &amp; Conditions • Privacy Policy • Contact Support:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="normal-case text-white underline decoration-diag underline-offset-2 transition-colors duration-150 ease-out hover:text-diag" data-id="element-62" data-mp="29xvrce9uhfpu">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </footer>;
}